export default "<app-rectangle-shape [shape]=\"task.rectangleShape\"></app-rectangle-shape>"